import {ChangeDetectionStrategy, Component} from '@angular/core';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {MelLinkComponent} from '@lib/components/mel-link/mel-link.component';

@Component({
  selector: 'px-mel-hint-link',
  template: `
    @if (organizationSelectors.usesMEL | select) {
      <p class="text-title-medium">Can't find what you're looking for?</p>
      <px-mel-link introText="Maybe it's in the ILL!"/>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, MelLinkComponent]
})
export class MelHintLinkComponent {

  public readonly organizationSelectors = OrganizationSelectors.Auth;
}
